export enum Views {
  Dashboards = 'DASHBOARDS',
}
